module.exports = __webpack_public_path__ + "img/img_asset_waterwheel_s.1aab873f.svg";